const name = 'userActions';
const RECEIVED_ADMIN = `${name}_RECEIVED_ADMIN`;
const RECEIVED_LOGOUT = `${name}_RECEIVED_LOGOUT`;
const RECEIVED_LOG_USER_IN = `${name}_RECEIVED_LOG_USER_IN`;
const RECEIVED_USER_INFO = `${name}_RECEIVED_USER_INFO`;
const RECEIVED_ROOM = `${name}_RECEIVED_ROOM`;
const UPDATE_CONFIRMATION_IND = `${name}_UPDATE_CONFIRMATION_IND`;
const LAUNCH_REMOTE_PROCTORING = `${name}_LAUNCH_REMOTE_PROCTORING`;
const TEST_ENGINE_ACTTAO = `acttao`;
const TEST_ENGINE_PSIUTD = `psiutd`;
const TEST_ENGINE_QUALTRICS = `qualtrics`;

export {
  RECEIVED_ADMIN,
  RECEIVED_LOGOUT,
  RECEIVED_LOG_USER_IN,
  RECEIVED_USER_INFO,
  RECEIVED_ROOM,
  UPDATE_CONFIRMATION_IND,
  LAUNCH_REMOTE_PROCTORING,
  TEST_ENGINE_ACTTAO,
  TEST_ENGINE_PSIUTD,
  TEST_ENGINE_QUALTRICS,
};
